import { SortingTypeIndexPeople } from "../pages/context/contextViewClear";


export enum SortingType {
    // latest = 'latest',
    popular = 'popular',
    moderation = 'moderation'
}

export enum SortingTypeIndex {
    price_inc = 10,
    price_dec = 9,
    // latest = 1,
    moderation = 1,
    popular = 2,
    current_competition = 1,
    ended_competition = 2,
    name = 3,
    projects = 4,
    opa = 5,
    score = 13,
    relevant = 20,
    course_start = 0,
    designer_name = 0,
    shop = 30,

    mediiia_all = 50,
    mediiia_author = 51,
    mediiia_education = 52
}

export const SortingTypeString: Record<SortingTypeIndex, string> = {
    // 1: 'latest',
    0: 'course_start',
    1: 'moderation',
    2: 'popular',
    3: 'name',
    4: 'project',
    5: 'opa',
    9: 'price_dec',
    10: 'price_inc',
    13: 'score',
    20: 'relevant',
    30: 'shop',

    50: 'mediiia_all',
    51: 'mediiia_author',
    52: 'mediiia_education',
};

export const SortingTypeStringPeople: Record<SortingTypeIndexPeople, string> = {
    0: 'name',
    1: 'name',
    2: 'name',
    3: 'name',
    4: 'opa'
};

export const SortingTypeStringCompetitions: any = {
    1: 'current_competition',
    2: 'ended_competition'
}
import { SortingTypeIndexPeople } from "../pages/context/contextViewClear";


export enum SortingType {
    // latest = 'latest',
    popular = 'popular',
    moderation = 'moderation'
}

export enum SortingTypeIndex {
    price_inc = 10,
    price_dec = 9,
    // latest = 1,
    moderation = 1,
    popular = 2,
    current_competition = 1,
    ended_competition = 2,
    name = 3,
    projects = 4,
    opa = 5,
    score = 13,
    relevant = 20,
    course_start = 0,
    designer_name = 0,
    shop = 30,

    mediiia_all = 50,
    mediiia_author = 51,
    mediiia_education = 52
}

export const SortingTypeString: Record<SortingTypeIndex, string> = {
    // 1: 'latest',
    0: 'course_start',
    1: 'moderation',
    2: 'popular',
    3: 'name',
    4: 'project',
    5: 'opa',
    9: 'price_dec',
    10: 'price_inc',
    13: 'score',
    20: 'relevant',
    30: 'shop',

    50: 'mediiia_all',
    51: 'mediiia_author',
    52: 'mediiia_education',
};

export const SortingTypeStringPeople: Record<SortingTypeIndexPeople, string> = {
    0: 'name',
    1: 'name',
    2: 'name',
    3: 'name',
    4: 'opa'
};

export const SortingTypeStringCompetitions: any = {
    1: 'current_competition',
    2: 'ended_competition'
}
